import {momentRange} from "../../../../../../gd/convert/moment-range";
import {TimeReportType} from "../../../../../../../views/reports/time-reports/@types";


export default class ReportEffortsDistributionByProject_Settings {

    public daterange      : DateRange
    public projectId      : ID | null
    public timeReportType : TimeReportType

    constructor(data: any) {
        this.daterange      = data?.daterange ? momentRange(data.daterange.start, data.daterange.end) : momentRange(moment().subtract(1, "month"), moment())
        this.projectId      = _.get(data, "projectId", null)
        this.timeReportType = _.get(data, "timeReportType", TimeReportType.REPORTED)
    }

    // get reportTitle() {
    //     const project = gd.session.projects.get(this.projectId)
    //
    //     if(project){
    //         return project.name
    //     }
    //     else{
    //         return "All projects"
    //     }
    // }

    toJSON(): JSONObject {
        const result: JSONObject = {
            projectId        : this.projectId,
            timeReportType   : this.timeReportType,
        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
